module.exports = __webpack_public_path__ + "img/checked-shield-icon.cc788220.svg";